$(function () {
  $(document).off(".matcha");

  // Variant button click
  $(document).on("click.matcha", ".matcha_variant-btn", function () {
    var $btn = $(this);

    $(".matcha_variant-btn").removeClass("active");
    $btn.addClass("active");

    var price = $btn.data("price");
    var variantId = $btn.data("id");

    var url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    history.replaceState(null, null, url.toString());

    $(".matcha-option__price").text(price);

    // Swap active selling plan container
    // $(".matcha-freq__options").removeClass("is-active");
    // var $container = $(
    //   '.matcha-freq__options[data-variant-plans="' + variantId + '"]',
    // );
    if ($container.length) {
      $container.addClass("is-active");
      var $firstOpt = $container.find(".matcha-freq__option").first();
      $container.find(".matcha-freq__option").removeClass("is-selected");
      $firstOpt.addClass("is-selected");
      $(".matcha-freq__value").text($firstOpt.text().trim());
    }
  });

  // Quantity selector
  $(document).on("click.matcha", ".matcha-qty__btn--plus", function () {
    var $val = $(this).siblings(".matcha-qty__val");
    $val.text(parseInt($val.text()) + 1);
  });
  $(document).on("click.matcha", ".matcha-qty__btn--minus", function () {
    var $val = $(this).siblings(".matcha-qty__val");
    var cur = parseInt($val.text());
    if (cur > 1) $val.text(cur - 1);
  });

  // Add to cart
  $(document).on("click.matcha", ".add_to_cart-matcha-selector", function () {
    var item;
    if ($("#matcha-sub").hasClass("is-active")) {
      var $active = $(".matcha-freq__options.is-active");
      item = {
        id: $active.data("variant-plans"),
        quantity: 1,
        selling_plan: $active.find(".matcha-freq__option.is-selected").data("plan-id"),
      };
    } else {
      item = {
        id: $(".matcha_variant-btn.active").data("id"),
        quantity: parseInt($(".matcha-qty__val").text()) || 1,
      };
    }
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: [item] },
      dataType: "json",
      error: function () {
        alert("Error adding item to the cart.");
      },
    });
  });

  // Close frequency dropdown on outside click
  $(document).on("click.matcha", function () {
    $("#matcha-freq").removeClass("is-open");
  });
});

function matchaPurchaseSelect(type) {
  $("#matcha-otp").toggleClass("is-active", type === "otp");
  $("#matcha-sub").toggleClass("is-active", type === "sub");
  $(".matcha_selector-buy").toggleClass("otpActive", type === "otp");
  $(".matcha-variants_selector").toggleClass("subSelected", type === "sub");
  $(".matcha-qty__val").text(1);
}

function matchaFreqToggle(e) {
  e.stopPropagation();
  $("#matcha-freq").toggleClass("is-open");
}

function matchaFreqSelect(e, opt) {
  e.stopPropagation();
  var $el = $("#matcha-freq");
  var $opt = $(opt);
  $el.find(".matcha-freq__value").text($opt.text().trim());
  $el.find(".matcha-freq__option").removeClass("is-selected");
  $opt.addClass("is-selected");
  $el.removeClass("is-open");
}
